
import React from 'react';
import EntriesFilterRow from './ResultsTab/TableFilters/EntriesFilterRow';

interface FiltersType {
  selectedOptsType: string[];
  setSelectedOptsType: any;
  selectedOptsFreq: string[];
  setSelectedOptsFreq: any;
  selectedOptsStatus: string[];
  setSelectedOptsStatus: any;
}

const Filters: React.FC<FiltersType> = ({ selectedOptsType, setSelectedOptsType, selectedOptsFreq, setSelectedOptsFreq, selectedOptsStatus, setSelectedOptsStatus }) => {
  const ticketType = [
    {
      id: 1,
      name: 'Single Entry - People / Companies'
    },
    {
      id: 2,
      name: 'Single Entry - Products'
    },
    {
      id: 3,
      name: 'Multiple Entries'
    },
    {
      id: 4,
      name: 'Supplier Questionnaire'
    },
    {
      id: 5,
      name: 'Classification'
    }
  ];
  const screeningFreq = [
    {
      id: 1,
      name: 'Once'
    },
    {
      id: 2,
      name: 'Daily'
    },
    {
      id: 3,
      name: 'Weekly'
    },
    {
      id: 4,
      name: 'Monthly'
    },
    {
      id: 5,
      name: 'Yearly'
    }
  ];

  const screeningStatus = [
    {
      id: 1,
      name: 'Pending'
    },
    {
      id: 2,
      name: 'Complete'
    },
    {
      id: 3,
      name: 'New Results'
    },
    {
      id: 4,
      name: 'Reviewed'
    },
    {
      id: 5,
      name: 'Approved'
    },
    {
      id: 6,
      name: 'Rejected'
    }
  ];


  return (
    <div className='full-list-filters'>
      <div className='full-list-filters-header'>
        Ticket Type
      </div>
      <div className='full-list-filters-cont'>
        {
          ticketType.map((row: any, index: number) => (
            <EntriesFilterRow
              key={index}
              name={row.name}
              selectedItems={selectedOptsType}
              setSelectedItems={setSelectedOptsType}
            />
          ))
        }
      </div>
      <div className='full-list-filters-header'>
        Screening Frequency
      </div>
      <div className='full-list-filters-cont'>
        {
          screeningFreq.map((row: any, index: number) => (
            <EntriesFilterRow
              key={index}
              name={row.name}
              selectedItems={selectedOptsFreq}
              setSelectedItems={setSelectedOptsFreq}
            />
          ))
        }
      </div>
      <div className='full-list-filters-header'>
        Status
      </div>
      <div className='full-list-filters-cont'>
        {
          screeningStatus.map((row: any, index: number) => (
            <EntriesFilterRow
              key={index}
              name={row.name}
              selectedItems={selectedOptsStatus}
              setSelectedItems={setSelectedOptsStatus}
            />
          ))
        }
      </div>
    </div>
  );
};

export default Filters;
